<template>
  <div class="news-right">
    <div class="right-hd">
      {{ details.SERVICE_NUM }}
    </div>
    <div class="right-bd">
      <p class="bd-hd">
        <span>{{ details.SERVICE_NUM }}</span>
        <span>{{ details.CREATE_TIME }}</span>
      </p>
      <p class="bd-title">{{ details.TITLE }}</p>
      <p class="bd-content">{{ details.CONTENT }}</p>
      <p class="bd-store">
        <span class="bd-store-label">门店名称：</span>
        <span>{{ details.STORE_ID_DESC }}</span>
      </p>
      <p class="bd-store">
        <span class="bd-store-label">门店地址：</span>
        <span>{{ details.STORE_ADDRESS }}</span>
      </p>
      <p class="bd-type">
        <span class="bd-store-label">当前状态：</span>
        <span>{{ details.NEWS_TYPE_DESC }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      details: {}
    }
  },
  mounted () {
    this.$bus.$on('detailNews', params => this.details = params )
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/news/details.vue